import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch4_p10 } from "../../../layouts/ch4_p10/ch4_p10"

export class Chapter4Page10 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly doorOpen = this.addChild(new SceneSprite());
    readonly doorClosed = this.addChild(new SceneSprite());
    readonly guitar = this.addChild(new SceneSprite());
    readonly basket = this.addChild(new SceneSprite());
    readonly holly = [
        this.addChild(new SceneSprite()),
        this.addChild(new SceneSprite()),
    ];
    readonly sigh = this.addChild(new SceneSprite());

    readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch4_p10/"));
    readonly frameRight = this.addChild(SceneSprite.withPrefix("ch4_p10/"));
    readonly linesLeft = this.addChild(new SceneSprite());

    dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch4_p10.call(this);

        this.holly[1].visible = false;
        this.doorOpen.visible = false;

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        new TimelineLite()
            .call(()=>{
                this.holly[0].FadeOut();
                this.sigh.FadeOut();

                this.holly[1].FadeIn();
            }, undefined, undefined, 1.5)
            .call(()=>{
                this.doorClosed.FadeOut();
                this.doorOpen.FadeIn();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                super.onAnimateInComplete();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                this.gotoNextState({ transition: "fade" });
            }, undefined, undefined, "+=1.5")
        ;
    }
}